import React from 'react';
import { HeroSection } from './components/HeroSection';
import { IntroductionSection } from './components/IntroductionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TimelineSection } from './components/TimelineSection';
import { ComparisonSection } from './components/ComparisonSection';
import { CTASection } from './components/CTASection';
import { WarningSignsSection } from './components/WarningSignsSection';
import { IframeResizer } from './components/IframeResizer';
export function App() {
  return <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-0">
      <IframeResizer data-id="element-1" />
      <HeroSection data-id="element-2" />
      <IntroductionSection data-id="element-3" />
      <BenefitsSection data-id="element-4" />
      <WarningSignsSection data-id="element-5" />
      <TimelineSection data-id="element-6" />
      <ComparisonSection data-id="element-7" />
      <CTASection data-id="element-8" />
    </div>;
}